export function getStandaloneSearchBoxSetInitialState() {
    return {};
}
